// extracted by mini-css-extract-plugin
export var boldText = "_2h-4";
export var checkboxContainer = "_2h-6";
export var closeIcon = "_2h-g";
export var container = "_2h-0";
export var drawer = "_2h-8";
export var drawerContent = "_2h-9";
export var extraSmallText = "_2h-5";
export var fulfillmentGroupTable = "_2h-e";
export var largeText = "_2h-3";
export var loadingSpinnerContainer = "_2h-h";
export var mediumText = "_2h-2";
export var narrow = "_2h-f";
export var notificationLink = "_2h-j";
export var packageCheckIconContainer = "_2h-7";
export var slideoutHeaderContainer = "_2h-a";
export var slideoutModal = "_2h-c";
export var stickyHeaderWrapper = "_2h-b";
export var table = "_2h-i";
export var tableContainer = "_2h-d";
export var tertiaryText = "_2h-1";